import { FC } from 'react';
import { useSummaryStatus } from 'views/Engagement/hooks';
import EnpsSummaryCard from './EnpsSummaryCard';
import { EnpsSummaryResponse } from './types';

interface EnpsSummaryTaskCardProps {
  campaignId: number;
  reportItemId?: number;
}

const EnpsSummaryTaskCard: FC<EnpsSummaryTaskCardProps> = () => {
  // Get shared data from context (fetched by UnifiedSummaryGenerationCard)
  const { enpsData } = useSummaryStatus();

  const summary = enpsData?.summary as EnpsSummaryResponse | undefined;

  // Only render when there's actual summary data to display
  // The unified AI Summaries card handles loading/error/generation states
  if (!summary || Object.keys(summary).length === 0) {
    return null;
  }

  return <EnpsSummaryCard data={summary} />;
};

export default EnpsSummaryTaskCard;
